import { useTranslation } from 'next-i18next';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import AutoColumnsGrid from '../../new-components/display-system/AutoColumnsGrid';
import NoResultsIndicator from '../../new-components/NoResultsIndicator';
import ToggleInput from '../../new-components/ToggleInput';
import MapSearchResultsToCards from '../search/components/search-results/MapSearchResultsToCards';
import useGetFavorites from './hooks/GetFavorites';
import NawyLoadingIndicator from '../../new-components/NawyLoadingIndicator';
import { useSelector } from 'react-redux';

const Favorite = () => {
  const { t } = useTranslation('favorite');
  const { favorites, isLoading } = useGetFavorites();

  const [choosen, setChoosen] = useState(
    favorites.compounds.length > 0
      ? 'compound'
      : favorites.properties.length > 0
        ? 'property'
        : 'compound'
  );

  const getFavoritesResults = useCallback(() => {
    if (isLoading) {
      return <NawyLoadingIndicator />;
    }

    if (favorites.compounds.length === 0 && favorites.properties.length === 0) {
      return <NoResultsIndicator />;
    }

    if (choosen == 'property') {
      if (favorites.properties.length > 0) {
        return (
          <AutoColumnsGrid columnsGap="16px" rowsGap="16px" minWidth="445px">
            <MapSearchResultsToCards
              searchResults={favorites.properties}
              findType={choosen}
              searchLocation="FavoritesPage"
            />
          </AutoColumnsGrid>
        );
      } else {
        return <NoResultsIndicator />;
      }
    } else {
      if (favorites.compounds.length > 0) {
        return (
          <AutoColumnsGrid columnsGap="16px" rowsGap="16px" minWidth="445px">
            <MapSearchResultsToCards
              searchResults={favorites.compounds}
              findType={choosen}
              searchLocation="FavoritesPage"
            />
          </AutoColumnsGrid>
        );
      } else {
        return <NoResultsIndicator />;
      }
    }
  }, [favorites, isLoading, choosen]);

  return (
    <Container>
      <div className="togglebutton">
        <ToggleInput
          buttonsData={[
            { key: 'compound', label: t('compounds') },
            { key: 'property', label: t('properties') }
          ]}
          choosenInput={choosen}
          setChoosenInput={setChoosen}
        />
      </div>
      <div className="subcontainer">
        {choosen == 'property' ? (
          <div className="results">
            <h1 className="headline-3">{t('available_properties')}</h1>
            {favorites.properties && (
              <span>{favorites.properties.length + ' ' + t('results')}</span>
            )}
          </div>
        ) : (
          <div className="results">
            <h1 className="headline-3">{t('available_compounds')}</h1>
            {favorites.compounds && (
              <span>{favorites.compounds.length + ' ' + t('results')}</span>
            )}
          </div>
        )}

        <div className="favoriteItems">{getFavoritesResults()}</div>
      </div>
    </Container>
  );
};
const Container = styled.div`
  width: 73%;
  margin: auto;
  .togglebutton {
    width: 216px;
    margin-top: 16px;
  }
  .results {
    margin-top: 45px;
    display: flex;
    align-items: center;
    gap: 0px 5px;
    span {
      font-family: materialRegular;
      font-size: ${props => props.theme.font.sizes.s};
      color: ${props => props.theme.light.colors.darkGrey};
    }
  }
  .favoriteItems {
    padding: 18px 0px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    width: 100%;
    .subcontainer {
      padding: 16px 16px;
    }
    .togglebutton {
      width: 100%;
      margin-top: 0px;
    }
    .results {
      margin-top: 16px;
    }
    .favoriteItems {
      margin-top: 20px;
    }
  }
`;
export default Favorite;
